<template>
<!-- rf06 -->
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-flex shrink style="text-align: right"><v-btn dark @click="printPage()" style="width: 80px; background-color: black;"><v-icon>local_printshop</v-icon></v-btn></v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
        <div class="print-form">
        <v-layout mx-6>
          <v-flex>
            <v-layout style="background-color: #3E7662;">
              <v-flex
                my-4
                ml-8
                style="text-align: left;font-size: 28px;color: white"
              >
                <div style="font-weight: bold">
                  แบบประเมินรายงานแจ้งปิด/สรุปผลการวิจัย
                </div>
                <div style="font-size: 18px;">Closing Report/Final Report</div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                <span>RO 09_2563</span>
              </v-flex>
            </v-layout>

            <!-- Start Form -->

            <!-- Card 1 -->
            <v-card class="mb-12">
              <v-layout pa-12 class="justify-center">
                <v-flex xs10>
                  <!-- row 1 -->
                  <v-layout mb-8>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                      <b>รหัสโครงร่างการวิจัย</b>
                    </v-flex>
                    <v-flex xs4 class="text-start">
                      <TextfieldForm
                        readonly
                        :model="form.researchCode"
                        hide-detail
                        @update-data="updateData('researchCode', $event)"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout mb-8>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                      <b>ชื่อผู้วิจัยหลัก</b>
                    </v-flex>
                    <v-flex xs4 class="text-start">
                      <TextfieldForm
                        readonly
                        :model="form.firstName"
                        hide-detail
                        @update-data="updateData('firstName', $event)"
                      />
                    </v-flex>
                    <v-flex mx-4 xs1 class="d-flex justify-end align-center">
                      <b>นามสกุล</b>
                    </v-flex>
                    <v-flex>
                      <TextfieldForm
                        readonly
                        :model="form.lastName"
                        hide-detail
                        @update-data="updateData('lastName', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                      <b>ชื่อโครงการวิจัย (ไทย)</b>
                    </v-flex>
                    <v-flex>
                      <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Card 2 -->
            <v-card class="pa-12">
              <!-- Text 1 -->
              <v-layout py-6 pl-12>
                <v-flex>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Accrual ceiling set by IEC/IRB</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="accrualCeiling"
                            :model="form.accrualCeiling"
                            style="font-weight: bold"
                            @update-data="updateData('accrualCeiling', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total accrued participants</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalParticipants"
                            :model="form.totalParticipants"
                            style="font-weight: bold"
                            @update-data="
                              updateData('totalParticipants', $event)
                            "
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total participants fail screening</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalScreening"
                            :model="form.totalScreening"
                            style="font-weight: bold"
                            @update-data="updateData('totalScreening', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total participants withdrawn</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalWithdrawn"
                            :model="form.totalWithdrawn"
                            style="font-weight: bold"
                            @update-data="updateData('totalWithdrawn', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total participants dead</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalDead"
                            :model="form.totalDead"
                            style="font-weight: bold"
                            @update-data="updateData('totalDead', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total participants complete the research</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalCompleteResearch"
                            :model="form.totalCompleteResearch"
                            style="font-weight: bold"
                            @update-data="
                              updateData('totalCompleteResearch', $event)
                            "
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- Group 2 -->
              <v-layout pt-8>
                <v-flex d-flex justify-start>
                  <span style="font-weight: bold;font-size: 18px;"
                    >Summary of Protocol Participants</span
                  >
                </v-flex>
              </v-layout>
              <v-layout pt-6 pb-12 pl-12>
                <v-flex>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total participants experience adverse events</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalExpAdversEvents"
                            :model="form.totalExpAdversEvents"
                            style="font-weight: bold"
                            @update-data="
                              updateData('totalExpAdversEvents', $event)
                            "
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1 mb-4>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex align-center xs6">
                          <span style="color: #3E7662;"
                            >Total participants experience SUSARs</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalExpSUSARs"
                            :model="form.totalExpSUSARs"
                            style="font-weight: bold"
                            @update-data="updateData('totalExpSUSARs', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-1>
                    <v-flex d-flex justify-start>
                      <v-layout>
                        <v-flex class="d-flex text-start xs6">
                          <span style="color: #3E7662;"
                            >Total global participants experience SUSARs, if
                            applicable</span
                          >
                        </v-flex>
                        <v-flex class="xs3">
                          <textfield-form
                            type="number"
                            hide-detail
                            id="totalGlobal"
                            :model="form.totalGlobal"
                            style="font-weight: bold"
                            @update-data="updateData('totalGlobal', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!-- Has there been any protocol deviation/violation or compliance issues occurred during the study? -->
              <v-layout style="margin-top: 100px">
                <v-flex class="font-weight-bold text-start">
                  <span
                    >Has there been any protocol deviation/violation or
                    compliance issues occurred during the study?</span
                  >
                </v-flex>
              </v-layout>
              <v-layout class="px-12 mt-6">
                <v-flex class="text-start" style="color: #3E7662">
                  <v-radio-group
                    v-model="form.hasProtocol"
                    row
                    :readonly="$route.query.read == 1"
                  >
                    <v-radio
                      style="padding-right: 70px"
                      color="#3E7662"
                      label="NO"
                      value="0"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="YES (please attach a report)"
                      value="1"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.hasProtocol === '1'">
                <v-flex shrink>
                  <span
                    v-if="anyProtocolFile"
                    class="text-start linkPDF"
                    style="font-size: 16px;color: #CC3D45;"
                    @click="
                      () => {
                        window.open(anyProtocolFilePath);
                      }
                    "
                  >
                    File: {{ anyProtocolFile }}
                  </span>
                  <span
                    v-else
                    class="text-start"
                    style="font-size: 12px;color: #CC3D45;"
                  >
                    File: ไม่มี
                  </span>
                </v-flex>
              </v-layout>

              <!-- Has there been any complaint or warning letter against the research or investigator during the study? -->
              <v-layout class="mt-12">
                <v-flex class="font-weight-bold text-start">
                  <span
                    >Has there been any complaint or warning letter against the
                    research or investigator during the study?</span
                  >
                </v-flex>
              </v-layout>
              <v-layout class="px-12 mt-6">
                <v-flex class="text-start" style="color: #3E7662">
                  <v-radio-group
                    v-model="form.hasComplaint"
                    row
                    :readonly="$route.query.read == 1"
                  >
                    <v-radio
                      style="padding-right: 70px"
                      color="#3E7662"
                      label="NO"
                      value="0"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="YES (please attach a report)"
                      value="1"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout v-if="form.hasComplaint === '1'">
                <v-flex shrink>
                  <span
                    v-if="anyComplaintFile"
                    class="text-start linkPDF"
                    style="font-size: 16px;color: #CC3D45;"
                    @click="open(anyComplaintFilePath)"
                  >
                    File: {{ anyComplaintFile }}
                  </span>
                  <span
                    v-else
                    class="text-start"
                    style="font-size: 12px;color: #CC3D45;"
                  >
                    File: ไม่มี
                  </span>
                </v-flex>
              </v-layout>

              <!-- Are there any benefit or negative impact to participants after the study completion? -->
              <v-layout class="mt-12">
                <v-flex class="font-weight-bold text-start">
                  <span
                    >Are there any benefit or negative impact to participants
                    after the study completion?</span
                  >
                </v-flex>
              </v-layout>
              <v-layout class="px-12 mt-6">
                <v-flex class="text-start" style="color: #3E7662">
                  <v-radio-group
                    v-model="form.hasImpact"
                    row
                    :readonly="$route.query.read == 1"
                  >
                    <v-radio
                      style="padding-right: 70px"
                      color="#3E7662"
                      label="NO"
                      value="0"
                    ></v-radio>
                    <v-radio
                      color="#3E7662"
                      label="YES (please attach a report)"
                      value="1"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <!-- Comments -->
              <v-layout class="mb-4" style="margin-top: 100px">
                <v-flex class="text-start">
                  <span class="font-weight-bold">Comments</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <TextareaForm
                    :readonly="$route.query.read == 1"
                    :rows="8"
                    :model="form.commentTextBox"
                    @update-data="updateData('commentTextBox', $event)"
                  />
                </v-flex>
              </v-layout>

              <!-- Reviewer Decision -->
              <v-layout mt-10>
                <v-flex class="text-start font-weight-bold">
                  <span>Reviewer Decision</span>
                </v-flex>
              </v-layout>
              <v-layout class="ml-6 mt-4">
                <v-flex shrink>
                  <v-radio-group
                    v-model="form.reviewerDecision"
                    :readonly="$route.query.read == 1"
                  >
                    <v-radio
                      class="mb-4"
                      color="#3E7662"
                      label="Acknowledgement"
                      value="1"
                    ></v-radio>
                    <v-radio
                      class="mb-4"
                      color="#3E7662"
                      label="Acknowledgement / more information needed"
                      value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <!-- Reviewer Signature -->
              <v-layout style="margin-top: 130px;">
                <v-flex xs6>
                  <v-layout>
                    <v-flex
                      xs4
                      mr-4
                      mt-4
                      class="justify-end font-weight-bold d-flex align-center"
                    >
                      <span>Reviewer Signature</span>
                    </v-flex>
                    <v-flex xs6 class="text-start text-field-center">
                      <v-text-field
                        :readonly="$route.query.read == 1"
                        hide-details
                        v-model="form.signature"
                        color="#3E7662"
                        append-icon="edit"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs4 mr-4></v-flex>
                    <v-flex xs6 class=" text-field-center">
                      <v-layout>
                        <v-flex mr-2 mt-5 shrink class="d-flex align-center">
                          <span>(</span>
                        </v-flex>
                        <v-flex>
                          <v-text-field
                            :readonly="$route.query.read == 1"
                            hide-details
                            v-model="form.signature"
                            color="#3E7662"
                          />
                        </v-flex>
                        <v-flex ml-2 mt-5 shrink class="d-flex align-center">
                          <span>)</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-flex>
                <v-flex xs6 class="text-end">
                  <v-layout>
                    <v-spacer></v-spacer>
                    <v-flex
                      shrink
                      mr-4
                      class="text-end font-weight-bold d-flex align-center"
                    >
                      <span>Date</span>
                    </v-flex>
                    <v-flex xs6 class="text-end">
                      <TextfieldForm
                        v-if="$route.query.read == 1"
                        hide-detail
                        :model="dateChange"
                      />
                      <DateInputForm
                        v-else
                        hide-detail
                        :model="dateChange"
                        @update-data="updateDate('date', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout class="pb-12" style="margin-top: 100px">
                <v-flex class="text-start font-weight-bold">
                  <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Button Save -->
            <v-layout mt-8>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="$router.go(-1)"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark class="mx-4" color="#3E7662" @click="saveDraft">
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                    <v-btn
                      v-if="$route.query.read == 0"
                      depressed
                      dark
                      color="#3E7662"
                      @click="save"
                    >
                      <span>บันทึกข้อมูลและส่งการประเมิน</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";
import { domain } from '../../services/Constants'

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    form: {
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      hasProtocol: "",
      hasComplaint: "",
      hasImpact: "",
      commentTextBox: "",
      reviewerDecision: "",
      signature: "",
      date: "",
    },
    dateChange: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.getRO09();
    if (this.$route.query.read != 1) {
      this.form.researchCode = this.$route.query.researchCode;
      this.form.researchName = this.$route.query.researchName;

      let name = this.$route.query.mainResearcher.split(" ");
      this.form.firstName = name[0];
      this.form.lastName = name[1];

      this.form.accrualCeiling = this.$route.query.accrualCeiling;
      this.form.totalParticipants = this.$route.query.totalParticipants;
      this.form.totalScreening = this.$route.query.totalScreening;
      this.form.totalWithdrawn = this.$route.query.totalWithdrawn;
      this.form.totalDead = this.$route.query.totalDead;
      this.form.totalCompleteResearch = this.$route.query.totalCompleteResearch;
      this.form.totalExpAdversEvents = this.$route.query.totalExpAdversEvents;
      this.form.totalExpSUSARs = this.$route.query.totalExpSUSARs;
      this.form.totalGlobal = this.$route.query.totalGlobal;
      this.form.hasProtocol = this.$route.query.hasIssue.toString();
      this.form.hasComplaint = this.$route.query.hasWarning.toString();
      this.form.hasImpact = this.$route.query.hasImpact.toString();

      this.form.anyProtocolFile = this.$route.query.anyProtocolFile;
      this.form.anyComplaintFile = this.$route.query.anyComplaintFile;

      this.anyComplaintFile = this.$route.query.anyComplaintFile;
      this.anyComplaintFilePath = `${this.domain}storage/upload/rf/rf06-affiliation/${this.$route.query.anyComplaintFile}`;
      this.anyProtocolFile = this.$route.query.anyProtocolFile;
      this.anyProtocolFilePath = `${this.domain}storage/upload/rf/rf06-affiliation/${this.$route.query.anyProtocolFile}`;

      this.form.isPlan = this.$route.query.isPlan;
      this.form.isFollowUp = this.$route.query.isFollowUp;
      this.form.followUp = this.$route.query.followUp;
      this.form.plan = this.$route.query.plan;
    }
  },
  methods: {
     async printPage() {
      this.printMode = true
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
          "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
          element.innerHTML = '✓' + element.innerHTML
        })
      await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
          element.innerHTML = '✓ ' + element.innerHTML
        })
      var node = document.getElementById("print");
      var self = this;
      domtoimage
          .toPng(node)
          .then( async function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            var page = self.imageToPrint(img);

            var pageLink = "about:blank";
            var pwa = window.open(pageLink, "_new");
            pwa.document.open();
            pwa.document.write(page);
            pwa.document.close();
            self.printMode = false
            await document.querySelectorAll("button").forEach(function (element) {
              element.style.display = 'unset'
            });
            await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
              element.innerHTML = element.innerHTML.replace('✓', '')
            })
            await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
              element.innerHTML = element.innerHTML.replace('✓ ', '')
            })
            await document.querySelectorAll(".v-icon").forEach(function (element) {
              element.style.display = 'unset'
            });
            document
                .getElementsByClassName("print-form")[0]
                .removeAttribute("style");
          })
          .catch(function (error) {
            Swal.fire({
              title: "กรุณาเปิดการอนุญาต Pop Up!",
              description: "",
              icon: "error",
              confirmButtonColor: "#3E7662",
              cancelButtonColor: "rgb(189, 189, 189)",
              confirmButtonText: "ตกลง",
            }).then(async function() {

              await document.querySelectorAll("button").forEach(function (element) {
                element.style.display = 'unset'
              });
              await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
                element.innerHTML = element.innerHTML.replace('✓', '')
              })
              await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
                element.innerHTML = element.innerHTML.replace('✓ ', '')
              })
              await document.querySelectorAll(".v-icon").forEach(function (element) {
                element.style.display = 'unset'
              });
              document
                  .getElementsByClassName("print-form")[0]
                  .removeAttribute("style");
            })
          });
    },
    imageToPrint(source) {
      return (
          "<html><body onload='window.print()'><style>@media print {\n" +
          "  @page { margin: 0; }\n" +
          "  html, body {\n" +
          "    margin: 0;\n" +
          "    width: 210mm;\n" +
          "    height: 297mm;\n" +
          "  }\n" +
          "  img {\n" +
          "    margin-top: 10mm;\n" +
          "    margin-left: 20mm;\n" +
          "    width: 170mm;\n" +
          // "    height: 297mm;\n" +
          "  }\n" +
          "}</style>" +
          source.outerHTML +
          "</body></html>"
      );
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "date") {
        this.form.date = val.date;
        this.dateChange = this.changeDate(val.date);
      }
      if (name === "dateGet") {
        this.form.date = val;
        this.dateChange = this.changeDate(val);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveRO09", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    saveDraft() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveDraftRO09", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    async getCreateRO09Data(){
      this.isLoading = true;
      await this.$store
          .dispatch("FormRO/getCreateRO09", {
            researchID: this.$route.query.id,
            rfID: this.$route.query.rfID,
          })
          .then((res) => {
            this.updateDate("date", { date: new Date().toISOString().substr(0, 10) });
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            const splitName = res.mainResearcher.split(" ");
            this.form.firstName = splitName[0];
            this.form.lastName = splitName[1];
            this.form.researchName = res.researchName;
            this.form.signature = res.reviewer.thName;
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });

    },
    getRO09() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getRO09", this.$route.query.rfID)
        .then((res) => {
          if (res !== "don't have ro09 yet") {
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.accrualCeiling = res.accrualCeiling;
            this.form.totalParticipants = res.totalParticipants;
            this.form.totalScreening = res.totalScreening;
            this.form.totalWithdrawn = res.totalWithdrawn;
            this.form.totalDead = res.totalDead;
            this.form.totalCompleteResearch = res.totalCompleteResearch;
            this.form.totalExpAdversEvents = res.totalExpAdversEvents;
            this.form.totalExpSUSARs = res.totalExpSUSARs;
            this.form.totalGlobal = res.totalGlobal;
            this.form.hasProtocol = res.hasProtocol.toString();
            this.form.hasComplaint = res.hasComplaint.toString();
            this.form.hasImpact = res.hasImpact.toString();
            this.form.commentTextBox = res.commentTextBox;
            this.form.reviewerDecision = res.reviewerDecision.toString();
            this.form.signature = res.signature;
            this.updateDate("dateGet", res.date);
          }

          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.getCreateRO09Data()
        });
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {
  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }
    tr {
      border-top: 1px solid #544a44;
      border-bottom-: 1px solid #544a44;
    }
    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}
.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
</style>
